import "react";
import { ColorCircle } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Scheduling/shared/ShiftStatusLabel.tsx
var SHIFT_STATUS_LABELS = {
	completed: "Completed",
	ended: "Ended",
	inprogress: "In-Progress",
	missed: "Missed",
	notended: "Not Ended",
	notstarted: "Not Started",
	onbreak: "On Break"
};
function ShiftStatusLabel({ shift }) {
	const title = shift?.status?.title ? SHIFT_STATUS_LABELS[shift.status.title] || shift.status.title : null;
	if (!shift?.status || !title) return null;
	return /* @__PURE__ */ jsxs("span", { children: [shift.status?.color && /* @__PURE__ */ jsx(ColorCircle, {
		color: shift.status.color,
		marginRight: true
	}), title] });
}
//#endregion
export { ShiftStatusLabel };

//# sourceMappingURL=ShiftStatusLabel.js.map